import Button from "components/Button";
import Content from "components/Content";
import Label from "components/Label";
import useScreenSize from "hooks/use-screen-size";
import Image from "next/image";
import { useRouter } from "next/router";
import React, { FC } from "react";

import styles from "./styles.module.scss";

export interface Props {
  title: string;
  subtitle?: string;
  image?: string;
}

const Heading: FC<Props> = ({ title, subtitle, image }) => {
  const router = useRouter();

  const { isResponsive, isMobile, isTablet } = useScreenSize();

  return (
    <Content
      contentClassName={styles.container}
      containerClassName={styles.wrapper}
    >
      <img
        className={styles.hero}
        src={image || "/blog/header.jpg"}
        alt="Header"
      />
      <div className={styles.leftPanel}>
        <Label
          className={styles.partnersNetwork}
          variant="s-capitalized"
          color={isMobile || isTablet ? "white" : "lightPrimary"}
        >
          {subtitle || "Our Partner Network"}
        </Label>
        <div className={styles.titleWrapper}>
          <Label
            className={styles.title}
            useMarkdown
            variant="h"
            color={isMobile || isTablet ? "white" : "lightPrimary"}
          >
            {title}
          </Label>
        </div>
        <div className={styles.subtitleWrapper}>
          <Label
            className={styles.subtitle}
            useMarkdown
            variant="s"
            color={isMobile || isTablet ? "white" : "lightPrimary"}
          >
            Our partner network can help you get through your lingering
            punchlist and turn your dream home into a reality
          </Label>
        </div>
        <Button onClick={() => router.push("/start")} variant="cta">
          Get Started
        </Button>
      </div>
      <div className={styles.rightPanel}>
        <Image
          alt=""
          src={image || "/services/landers/home-improvements.png"}
          layout="cover"
          width={isResponsive ? (isMobile ? 250 : 300) : 535}
          height={isResponsive ? (isMobile ? 250 : 300) : 535}
        />
      </div>
    </Content>
  );
};

export default Heading;
